import React from 'react';
import userglobal from './home_assets/user_guide.svg';
import card1 from './home_assets/global_card1.svg';
import card2 from './home_assets/global_card2.svg';
import card3 from './home_assets/global_card3.svg';
import card4 from './home_assets/global_card4.svg';

import './home_styles/homeglobal.css';
import { Card, Col, Container, Row } from 'react-bootstrap';

export default function HomeGlobal() {
  return (
    <div className='home_global'>
      <Container>
        <Row>
          <Col>
           <div className="user_global_upper">
                <div className="global_upper_img text-center">
                  <img src={userglobal} alt="Userguide" />
                </div>
                <div className="global_upper_head d-flex flex-column align-items-center">
                  <h1>GLOBAL PRESENCE</h1>
                  <span>Borderless, community decentralization and autonomy, team decentralize is the
                    ultimate form of SuperEx development.
                  </span>
                </div>
            </div>
            <div className="user_global_lower">
              <div className="global_cards d-flex gap-1 mt-4 mb-4">
                <Row className=''>
                <Col xl={3} lg={6} sm={12} className='my-2'>
                <Card className='py-4 glob_cards'>
                  <div className='text-center glob_img rounded-circle'>
                    <Card.Img className='w-100' variant='top' src={card1} />
                  </div>
                  <Card.Body className='d-flex flex-column align-items-center text-center'>
                    <Card.Title>ZERO SECURITY RISK</Card.Title>
                    <Card.Text>
                    Decentralized SuperWallet is integrated,
                    and the private key is encrypted and stored
                    on the user device. Not affected by code security,
                    politics and other factors.
                    </Card.Text>
                  </Card.Body>
                </Card>
                </Col>
                <Col xl={3} lg={6} sm={12} className='my-2'>
                <Card className='py-4 glob_cards'>
                  <div className='text-center glob_img rounded-circle'>
                    <Card.Img className='w-100' variant='top' src={card2} />
                  </div>
                  <Card.Body className='d-flex flex-column align-items-center text-center'>
                    <Card.Title>NO REGISTRATION & KYC</Card.Title>
                    <Card.Text>
                    Decentralized SuperWallet is integrated,
                    and the private key is encrypted and stored
                    on the user device. Not affected by code security,
                    politics and other factors.
                    </Card.Text>
                  </Card.Body>
                </Card>
                </Col>
                <Col xl={3} lg={6} sm={12} className='my-2'>
                <Card className='py-4 glob_cards'>
                  <div className='text-center glob_img rounded-circle'>
                    <Card.Img className='w-100' variant='top' src={card3} />
                  </div>
                  <Card.Body className='d-flex flex-column align-items-center text-center'>
                    <Card.Title>OPEN SYSTEM (Q2)</Card.Title>
                    <Card.Text>
                    Decentralized SuperWallet is integrated,
                    and the private key is encrypted and stored
                    on the user device. Not affected by code security,
                    politics and other factors.
                    </Card.Text>
                  </Card.Body>
                </Card>
                </Col>
                <Col xl={3} lg={6} sm={12} className='my-2'>
                <Card className='py-4 glob_cards'>
                  <div className='text-center glob_img rounded-circle'>
                    <Card.Img className='w-100' variant='top' src={card4} />
                  </div>
                  <Card.Body className='d-flex flex-column align-items-center text-center'>
                    <Card.Title>SPACE FUND</Card.Title>
                    <Card.Text>
                    Decentralized SuperWallet is integrated,
                    and the private key is encrypted and stored
                    on the user device. Not affected by code security,
                    politics and other factors.
                    </Card.Text>
                  </Card.Body>
                </Card>
                </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
